var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import useVirtual from 'react-cool-virtual';
import { createSelector } from '@reduxjs/toolkit';
import { useGetPollListsQuery } from '../../store/services/pollsApi';
import Poll from './poll';
import { store, useAppSelector } from '../../store';
const screenHeightSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.screenHeight);
$RefreshReg$(_react_refresh_temp_1, "screenHeightSelector$createSelector");
const ListPolls = () => {
    var _a, _b;
    _react_refresh_temp_3();
    const screenHeight = useAppSelector(screenHeightSelector);
    const { data, isLoading } = useGetPollListsQuery();
    const isAdmin = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_admin;
    const [polls, setPolls] = useState([]);
    const { outerRef, innerRef, items } = useVirtual({
        itemCount: polls.length,
    });
    useEffect(() => {
        if (data && data.polls) {
            const sortedPolls = data.polls.slice();
            sortedPolls.sort((a, b) => Number(b.created) - Number(a.created));
            setPolls(sortedPolls);
        }
    }, [data]);
    const renderPoll = (index) => {
        if (!polls.length || typeof polls[index] === 'undefined') {
            return null;
        }
        const poll = polls[index];
        return _jsx(Poll, { item: poll }, poll.id);
    };
    return (_jsx("div", { className: "polls-list-wrapper relative overflow-auto scrollBar px-2 pt-2 xl:pt-3", style: { height: isAdmin ? screenHeight - 200 : screenHeight - 150 }, ref: outerRef, children: _jsxs("div", { className: "polls-list-wrap-inner", ref: innerRef, children: [items.map(({ index, measureRef }) => (_jsx("div", { ref: measureRef, className: "poll-item relative overflow-hidden border border-solid border-primaryColor/70 px-2 py-8 rounded-lg mb-4 transition ease-in hover:shadow-md", children: renderPoll(index) }, index))), isLoading ? (_jsx("div", { className: "loading absolute text-center top-1/2 -translate-y-1/2 z-[999] left-0 right-0 m-auto", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null] }) }));
};
_react_refresh_temp_2 = ListPolls;
$RefreshReg$(_react_refresh_temp_2, "ListPolls");
_react_refresh_temp_3(ListPolls, "9FuQU3yF9A4dyFVo3dp/pfDYmmU=", false, () => [useAppSelector, useGetPollListsQuery, useVirtual]);
export default ListPolls;
